'use client';

import dynamic from 'next/dynamic';

export const SportsSidebar = dynamic(
  () => import('./SportsSidebar').then((mod) => mod.SportsSidebar),
  { ssr: false },
);
